import { PlusOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import React from "react";
import { useDisclosure } from "../../../../../hooks/useDisclosure";
import { AppButton } from "../../../../atoms/Button";
import { Popup, PopupTitle } from "../../../../atoms/Popup";
import { Invoice } from "../types";
import { PendingInvoicesGrid } from "./PendingInvoicesGrid";

const { Text } = Typography;

type AddInvoicesButtonProps = {
  leaseId?: string;
  tenantId?: string;
  subtitle?: string;
  disabled?: boolean;
  addedInvoiceIds?: string[];
  onAddInvoice: (invoice: Invoice) => void;
};

export const AddInvoicesButton: React.FC<AddInvoicesButtonProps> = ({
  leaseId,
  tenantId,
  subtitle,
  disabled,
  addedInvoiceIds = [],
  onAddInvoice,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <AppButton
        variant="outlined"
        icon={<PlusOutlined />}
        disabled={disabled || !leaseId || !tenantId}
        onClick={onOpen}
      >
        Add Invoice
      </AppButton>

      <Popup
        destroyOnClose
        visibility={isOpen}
        title={<PopupTitle title="Add Invoice to this Payment" />}
        width="55rem"
        style={{ padding: 0 }}
        onCancel={onClose}
        content={
          <>
            {subtitle ? (
              <Text style={{ display: "block", marginBottom: 12, fontSize: 13, color: "#6b7280" }}>{subtitle}</Text>
            ) : null}

            <PendingInvoicesGrid
              leaseId={leaseId}
              tenantId={tenantId}
              isEnabled={isOpen}
              disabled={disabled}
              addedInvoiceIds={addedInvoiceIds}
              onAddInvoice={onAddInvoice}
            />
          </>
        }
      />
    </>
  );
};
